import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode
} from 'react'
import { TOTPGenerator } from '@/authenticator/TOTPGenerator'

interface TOTPTimerContextType {
  currentTime: number
  getRemainingTime: (period?: number) => number
}

const TOTPTimerContext = createContext<TOTPTimerContextType | undefined>(
  undefined
)

interface TOTPTimerProviderProps {
  children: ReactNode
}

export const TOTPTimerProvider = ({ children }: TOTPTimerProviderProps) => {
  const [currentTime, setCurrentTime] = useState(() => Date.now())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now())
    }, 50)

    return () => clearInterval(interval)
  }, [])

  const getRemainingTime = (period?: number) => {
    if (period && period !== TOTPGenerator.getPeriod()) {
      const secondsElapsed = (currentTime / 1000) % period
      return period - secondsElapsed
    }

    const totpPeriod = TOTPGenerator.getPeriod()
    const secondsElapsed = (currentTime / 1000) % totpPeriod
    return totpPeriod - secondsElapsed
  }

  return (
    <TOTPTimerContext.Provider value={{ currentTime, getRemainingTime }}>
      {children}
    </TOTPTimerContext.Provider>
  )
}

export const useTOTPTimer = () => {
  const context = useContext(TOTPTimerContext)
  if (context === undefined) {
    throw new Error('useTOTPTimer must be used within a TOTPTimerProvider')
  }
  return context
}
